import React, { useEffect, useState } from 'react';
/** Components */
import M_EMT_BASIC from './M_EMT_BASIC';
import { useSearch1 } from './M_EMT_BASIC_Query';
import { NavBarInfoActions } from '../../Reducer/NavBarInfoReducer';
import { useDispatch } from 'react-redux';

function M_EMT_BASICF() {
  const dispatch = useDispatch();

  const [emTelList, setEmTelList] = useState([]); // 비상연락처 list
  useEffect(() => {
    dispatch(NavBarInfoActions.setType('appBarDefault'));
  }, []);

  const { refetch: Search1 } = useSearch1({
    onSuccess: (rows) => {
      setEmTelList(rows);
    },
  });

  return (
    <div
      className="wrap"
      style={{
        height: 'calc(100% - 56px)',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'auto',
      }}
    >
      <M_EMT_BASIC emTelList={emTelList} setEmTelList={setEmTelList} />
    </div>
  );
}

export default M_EMT_BASICF;
